<template>
  <div v-show="show" class="mask">
    <div class="dialog">
      <div class="title">
        <span>发送到邮箱</span>

        <a style="cursor: pointer;padding: 20px 20px 20px 20px" @click="closeShow">X</a>
      </div>
      <div class="content">
        <div class="content-item">
          <div class="content-item-label">
            电子邮箱
          </div>
          <input v-model="user_email" placeholder="请输入您的邮箱（50字以内）" maxlength="50" class="content-item-input"></input>
        </div>
        <div class="content-item">
          <div class="content-item-label">
            文件名
          </div>
          <input v-model="filename" placeholder="请输入您的文件名（30字以内）" maxlength="30" class="content-item-input"></input>
        </div>
        <div class="content-item">
          <div class="content-item-label">
            标题
          </div>
          <input v-model="title" placeholder="请输入您的邮箱标题（20字以内）" maxlength="20" class="content-item-input"></input>
        </div>
        <div class="content-item">
          <div class="content-item-label">
            正文内容
          </div>
          <textarea v-model="content" placeholder="请输入您的邮件正文（200字以内）" maxlength="200" class="content-item-textarea"></textarea>
        </div>
      </div>

      <div class="footer">

        <div @click="send" class="btn">
          发送到指定邮箱
        </div>
      </div>
    </div>

  </div>
</template>

<script>
    export default {
        name: "SendEmailDialog",
        props:{
            show:{
                require: true
            }
        },
        data(){
            return{
                user_email:'',
                filename:'',
                title:'',
                content:'',
            }
        },
        methods:{
            closeShow(){
                this.$emit('close',false)
            },
            send(){
                this.user_email?this.$emit('send',{
                    user_email:this.user_email,
                    filename:this.filename,
                    custom_data:{
                        title:this.title,
                        content:this.content
                    },
                    is_print:false,
                }):this.$message.warning({
                    message:'请输入邮箱'
                })

            }
        }
    }
</script>

<style scoped>
  .mask{
    background-color: rgba(0,0,0,0.4);

    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    z-index: 1000;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;
  }
  .dialog{
    width: 40%;
    background-color:white ;
    display: flex;
    align-items: center;
    flex-direction: column;
    border-radius: 4px;

  }
  .title{
    width: 95%;padding-left: 5%;display: flex;justify-content: space-between;align-items: center;
    font-size: 14px;color: #35315C;border-bottom: 1px dashed rgba(53,42,92,0.2);
    font-weight: 600;
  }

  .content{
    padding: 20px 8% 20px 8%;
    display: flex;
    flex-direction: column;
    width:85% ;
    align-items: center;
    border-bottom: 1px solid rgba(53,42,92,0.2);
  }
  .content-item{
    width: 86%;
    display: flex;
    align-items: center;
    padding: 6px 0;
  }

  .content-item-label{
    width: 20%;
    font-size: 13px;
    color: #35315C;
    font-weight: bold;
  }
  .content-item-input{
    width: 80%;
    height: 20px;
    padding: 10px;
    font-size: 12px;
    background-color: #F5F6FA;
    border: none;outline:none;
    border-radius: 4px;
    color: rgba(53,49,92,0.8);
  }

  .content-item-textarea{
    width: 80%;
    height: 100px;
    padding: 10px;
    font-size: 12px;
    background-color: #F5F6FA;
    border: none;outline:none;
    border-radius: 4px;
    color: rgba(53,49,92,0.8);
  }

  .footer{
    width: 90%;
    height: 56px;
    padding: 5px 5%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }


  .btn{
    width: 140px;
    text-align: center;
    border-radius:18px;
    color: #FFFFFF;
    font-size: 13px;
    cursor: pointer;
    line-height: 40px;
    background-color: #4B00A4;
  }



</style>
